import {Component, Input} from '@angular/core';
import {PROFILE_KIND} from '../../../../../../common/constants';

@Component({
    selector: 'tfl-bo-profile-kind-badge',
    template: `
        <span [ngClass]="kindBadgeClass">
            {{ kindBadgeTitle | translate }}
        </span>
    `
})
export class ProfileKindBadgeComponent {

    kindBadgeClass: any = {};
    kindBadgeTitle: string = '';

    @Input('kind')
    set _kind(kind: number) {
        this.kindBadgeClass = this.getKindBadgeClass(kind);
        this.kindBadgeTitle = this.getKindBadgeTitle(kind);
    }

    private getKindBadgeClass(kind: number): any {
        return {
            'label        ': true,
            'label-default': kind === PROFILE_KIND.CUSTOMER || kind === PROFILE_KIND.SUB_CLIENT,
            'label-info   ': kind === PROFILE_KIND.AGENT    || kind === PROFILE_KIND.INSTITUTIONAL_CLIENT,
            'label-primary': kind === PROFILE_KIND.SALESMAN || kind === PROFILE_KIND.SALESMAN_LEAD,
            'label-success': kind === PROFILE_KIND.WHITE_LABEL
        };
    }

    private getKindBadgeTitle(kind: number): string {
        switch (kind) {
            case PROFILE_KIND.CUSTOMER:
                return 'CUSTOMER.KIND.CUSTOMER';
            case PROFILE_KIND.AGENT:
                return 'CUSTOMER.KIND.AGENT';
            case PROFILE_KIND.SALESMAN:
                return 'CUSTOMER.KIND.SALESMAN';
            case PROFILE_KIND.SALESMAN_LEAD:
                return 'CUSTOMER.KIND.SALESMAN_LEAD';
            case PROFILE_KIND.WHITE_LABEL:
                return 'CUSTOMER.KIND.WHITE_LABEL';
            case PROFILE_KIND.INSTITUTIONAL_CLIENT:
                return 'CUSTOMER.KIND.INSTITUTIONAL_CLIENT';
            case PROFILE_KIND.SUB_CLIENT:
                return 'CUSTOMER.KIND.SUB_CLIENT';
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/profile.kind.badge.component.ts